module.exports = __webpack_public_path__ + "distVue/img/login1.85978d69.png";